import { useEffect } from "react";
import { useParams } from "react-router-dom";
import supportPrograms from "src/data/app/programs";
import { setThemeColors } from "src/helpers/common";
import { generateTheme } from "src/helpers/theme";

const useTheme = (supportProgramKey?: string) => {
  const params = useParams();
  const supportProgramKeyFromParams = params["support-program-key"];
  const supportProgramKeyNew = supportProgramKey || supportProgramKeyFromParams;
  const config =
    supportPrograms[supportProgramKeyNew as keyof typeof supportPrograms];

  // set theme colors
  useEffect(() => {
    if (config) {
      setThemeColors(generateTheme(config?.theme?.colors));
    }
  }, [config]);

  return config?.theme;
};

export default useTheme;
